/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Poweredby2Inputs */

const en_navtitles_poweredby2 = /** @type {(inputs: Navtitles_Poweredby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`POWERED BY`)
};

/**
* | output |
* | --- |
* | "POWERED BY" |
*
* @param {Navtitles_Poweredby2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_poweredby2 = /** @type {((inputs?: Navtitles_Poweredby2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Poweredby2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_poweredby2(inputs)
});
export { navtitles_poweredby2 as "navTitles_poweredBy" }